export const STORE_KEY = '$_exams';
